import React from "react";
import styles from './ticketLink.module.scss';
import { KoText } from "packages/typography";
import KoIcon from '@kwapio/icons';

function DocumentLink(props) {
  const { data, row, onCellClick, colName, onExtraClick } = props;
  

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper} >
        <KoIcon
          onClick={() => onExtraClick&& onExtraClick(row, colName)}
          className={styles.icon}
          name={'StarOutlined'}
          width={14}
          color={row?.isStarred ? 'var(--query)' : ''}
          height={14}
        />
        <KoText className={styles.text} text={data} onClick={() => onCellClick&& onCellClick(row, colName)}/>
      </div>
    </div>
  );
}

export default DocumentLink;
